import algoliasearch from 'algoliasearch';

const APP_ID = 'SVQZL5MGH4';
const SEARCH_KEY = 'fa126c2aa63df6f8e7591a0e1b5768c1';
const INDEX_NAME = 'listings';

export const searchClient = algoliasearch(APP_ID, SEARCH_KEY);
const index = searchClient.initIndex(INDEX_NAME);

export interface AlgoliaSearchParams {
    query: string;
    category?: string;
    page?: number;
    hitsPerPage?: number;
}

export const searchListings = async ({ query, category, page = 0, hitsPerPage = 12 }: AlgoliaSearchParams) => {
    try {
        const filters = ['status:ACTIVE']; // Only show active listings

        if (category && category !== 'All') {
            filters.push(`category:${category}`);
        }

        const result = await index.search(query, {
            filters: filters.join(' AND '),
            page,
            hitsPerPage
        });

        return {
            hits: result.hits.map((hit: any) => ({
                ...hit,
                id: hit.objectID, // Map objectID to id for frontend compatibility
                imageUrls: hit.imageUrls || hit.image_urls || [] // Normalize image field
            })),
            nbPages: result.nbPages,
            nbHits: result.nbHits
        };
    } catch (error) {
        console.error('Algolia Search Error:', error);
        throw error;
    }
};
